import {
    AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component,
    EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { UUID } from 'angular2-uuid';
import { Subscription } from 'rxjs';
import { PermissionHelper } from '../../../helpers/permissions.helper';
import { RTLHelper } from '../../../helpers/rtl.helper';
import { ContextEventHelper } from '../../../models/contextevent.model';
import { NavigationService } from '../../../services/navigation.service';
import { UsersService } from '../../../services/users.service';
import { SettingsEntry } from '../../pages/settings.page';

@Component({
    selector: 'evi-nav-tabs',
    templateUrl: './navigation.tabs.html',
    styleUrls: ['./navigation.tabs.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationTabsControl implements OnInit, AfterViewInit, OnDestroy {
    NavMode = 'side';
    NavOpenValue = true;
    get NavOpen() {
        return this.NavOpenValue;
    }
    set NavOpen(value) {
        this.NavOpenValue = value;
        NavigationService.NavOpenChanged.next({ Value: value, Instance: this.ID });
    }
    openTimeOut = -1;

    ViewInitialized = false;
    Style = {};
    NavStyle = {};
    SelectedNavigation: SettingsEntry;
    ID = UUID.UUID();
    @ViewChild('iconnav') iconnav: any;
    @ViewChild('childnav') childnav: any;

    //#region NavigationItems
    NavigationItemsValue = [];

    @Input()
    get NavigationItems() {
        return this.NavigationItemsValue;
    }
    set NavigationItems(val) {
        if (val != this.NavigationItemsValue) {
            this.SelectedNavigation = null;
            this.NavigationItemsValue = val;
            if (val) {
                val.forEach(x => {
                    x.NaviTabInstance = this;
                    let user = UsersService.ActiveUser.getValue();
                    if (user) {
                        if (user.IsAdministrator) {
                            x.SecurityValue = true;
                        } else {
                            if (x.Security) {
                                x.SecurityValue = PermissionHelper.GetRight(x.Security.Name, x.Security.Value);
                            } else {
                                x.SecurityValue = true;
                            }
                        }
                    }
                });
            }
            if (this.ViewInitialized) {
                this.checkNavi(false);
            }
            this.NavigationItemsChange.emit(this.NavigationItemsValue);
        }
        this.cdRef.detectChanges();
    }

    @Output() NavigationItemsChange = new EventEmitter<any>();


    //#endregion
    //#region DeepLinking
    DeepLinkingValue = true;

    @Input()
    get DeepLinking() {
        return this.DeepLinkingValue;
    }
    set DeepLinking(val) {
        this.DeepLinkingValue = val;
        this.DeepLinkingChange.emit(this.DeepLinkingValue);
    }

    @Output() DeepLinkingChange = new EventEmitter<any>();
    //#endregion
    //#region Level
    LevelValue = 0;

    @Input()
    get Level() {
        return this.LevelValue;
    }
    set Level(val) {
        this.LevelValue = val;
        this.generateStyle();
        this.LevelChange.emit(this.LevelValue);
    }

    @Output() LevelChange = new EventEmitter<any>();
    //#endregion

    //#region SelectionHandler
    SelectionHandlerValue: any;

    @Input()
    get SelectionHandler() {
        return this.SelectionHandlerValue;
    }
    set SelectionHandler(val) {
        this.SelectionHandlerValue = val;
        if (this.SelectionSetSubscription) {
            this.SelectionSetSubscription.unsubscribe();
            this.SelectionSetSubscription = null;
        }
        if (val && val.SelectionSet) {
            this.SelectionSetSubscription = val.SelectionSet.subscribe(() => {
                this.checkNavi(true);
            });
        }
        this.SelectionHandlerChange.emit(this.SelectionHandlerValue);
    }

    @Output() SelectionHandlerChange = new EventEmitter<any>();
    //#endregion

    RefreshSubscription: Subscription;
    SelectionSetSubscription: Subscription;

    constructor(private cdRef: ChangeDetectorRef, private router: Router) {
    }

    ngOnInit(): void {
        this.RefreshSubscription = NavigationService.Refresh.subscribe(id => {
            if (this.SelectedNavigation && this.SelectedNavigation.ID == id &&
                this.SelectedNavigation.UpdateFunction) {
                this.SelectedNavigation.UpdateFunction().then(() => {
                    this.cdRef.detectChanges();
                });
            }
        });
        this.generateStyle();
    }

    ngAfterViewInit(): void {
        this.checkNavi(false);
        this.ViewInitialized = true;
    }

    ngOnDestroy(): void {
        if (this.RefreshSubscription) {
            this.RefreshSubscription.unsubscribe();
            this.RefreshSubscription = null;
        }
        if (this.SelectionSetSubscription) {
            this.SelectionSetSubscription.unsubscribe();
            this.SelectionSetSubscription = null;
        }
    }

    generateStyle() {
        this.Style['background-color'] = '#222222';
        this.Style['color'] = '#ffffff';
        this.NavStyle['background-color'] = '#0F3443';
        this.NavStyle['color'] = '#38EF7D';
    }

    async itemClicked(nav: any) {
        await this.selectItem(nav);
        if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.OnNavClicked === 'function') {
            this.SelectionHandlerValue.OnNavClicked(nav);
        }
    }

    async selectItem(nav: any) {
        if (nav !== this.SelectedNavigation) {
            if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.CheckComponent === 'function') {
                const retVal = await this.SelectionHandlerValue.CheckComponent();
                if (!retVal) {
                    return;
                }
            }
            if (this.DeepLinking) {
                if (nav != null) {
                    if (this.SelectionHandlerValue && this.SelectionHandlerValue.NavigationItems) {
                        let path = this.findItem(nav, this.SelectionHandlerValue.NavigationItems);
                        let url = "";
                        let count = 0;
                        path.forEach((p) => {
                            if (count > 0) {
                                url += "/";
                            }
                            url += p;
                            count += 1;
                        });

                        this.NavigationItemsValue.forEach(function (n) {
                            n.Selected = false;
                        });
                        if (nav) {
                            nav.Selected = true;
                            window.clearTimeout(this.openTimeOut);
                            this.NavOpen = false;
                            this.NavMode = 'over';
                        } else {
                            this.NavOpen = true;
                            this.NavMode = 'side';
                        }
                        if (this.SelectionHandlerValue.BaseURL[this.SelectionHandlerValue.BaseURL.length - 1] != '/') {
                            this.SelectionHandlerValue.BaseURL += '/';
                        }
                        if (this.SelectionHandlerValue.ActiveURL.indexOf(this.SelectionHandlerValue.BaseURL + url) == -1) {
                            this.router.navigate([this.SelectionHandlerValue.BaseURL + url]);
                        }
                        this.SetSelected(nav);
                    }
                }
            } else {
                this.NavigationItemsValue.forEach(function (n) {
                    n.Selected = false;
                });
                if (nav) {
                    nav.Selected = true;
                    window.clearTimeout(this.openTimeOut);
                    this.NavOpen = false;
                    this.NavMode = 'over';
                } else {
                    this.NavOpen = true;
                    this.NavMode = 'side';
                }
                this.SetSelected(nav);
            }
            if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.SetComponent === 'function') {
                this.SelectionHandlerValue.SetComponent(nav);
            }
        }
        this.cdRef.detectChanges();
    }

    private SetSelected(nav: SettingsEntry) {
        this.SelectedNavigation = nav;
        if (this.SelectedNavigation && this.SelectedNavigation.UpdateFunction
            && (!this.SelectedNavigation.Children || this.SelectedNavigation.Children.length == 0)) {
            this.SelectedNavigation.UpdateFunction().then(() => {
                this.cdRef.detectChanges();
            });
        }
    }

    findItem(nav: any, items: any[]) {
        let retVal = [];
        if (nav != null && items && items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (nav == item) {
                    retVal.push(item.ID);
                }
                if (item.Children && item.Children.length > 0) {
                    let result = this.findItem(nav, item.Children)
                    if (result && result.length > 0) {
                        retVal.push(item.ID);
                        retVal.push(...result);
                    }
                }
            }
        }
        return retVal;
    }

    checkNavi(fromSelectionSet: boolean) {
        if (this.NavigationItemsValue) {
            const selected = this.NavigationItemsValue.find(x => x.Selected);
            if (selected) {
                window.clearTimeout(this.openTimeOut);
                this.NavOpen = false;
                this.NavMode = 'over';                
            } else {
                this.NavOpen = true;
                this.NavMode = 'side';
            }
            if (selected != this.SelectedNavigation) {
                this.SetSelected(selected);
                if (!fromSelectionSet && (!selected || !selected.Children || !selected.Children.some((x: any) => x.Selected)) &&
                    this.SelectionHandlerValue && typeof this.SelectionHandlerValue.SetComponent === 'function') {
                    this.SelectionHandlerValue.SetComponent(selected);
                }
            }
            this.cdRef.detectChanges();
        }
    }

    onMouseEnter() {
        if (this.NavMode === 'over') {
            this.openTimeOut = window.setTimeout(() => {
                this.NavOpen = true;
                ContextEventHelper.Close.next(null);
                if (this.childnav) {
                    this.childnav.closeNav();
                }
                this.cdRef.detectChanges();
            }, 500);
        }
    }

    onMouseLeave() {
        if (this.NavMode === 'over') {
            window.clearTimeout(this.openTimeOut);
        }
    }

    closeNav() {
        if (this.NavMode === 'over') {
            this.NavOpen = false;
            if (this.childnav) {
                this.childnav.closeNav();
            }
            this.cdRef.detectChanges();
        }
    }

    onScroll(ev: any) {
        if (ev && ev.target && this.iconnav && this.iconnav.nativeElement) {
            this.iconnav.nativeElement.scrollTop = ev.target.scrollTop;
        }
    }

    GetLevelStyle() {
        const baseWidth = 56; // Width of each nav item
        const margin = 0; // Total horizontal margin for each item
        if (RTLHelper.Direction == 'rtl') {
            return { 'right': ((this.LevelValue * (baseWidth + margin)) + 26) + 'px' }
        } else {
            return { 'left': ((this.LevelValue * (baseWidth + margin)) + 26) + 'px' }
        }
    }

    GetLevelStyleWithCheck() {
        const baseWidth = 56; // Width of each nav item
        const margin = 0; // Total horizontal margin for each item
        if (RTLHelper.Direction == 'rtl') {
            return { 'right': this.NavMode == 'over' ? ((this.LevelValue + 1) * (baseWidth + margin)) + 'px' : '0px', 'left': 0 }
        } else {
            return { 'left': this.NavMode == 'over' ? ((this.LevelValue + 1) * (baseWidth + margin)) + 'px' : '0px', 'right': 0 }
        }
    }
}
